import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardIllustration = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 95 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 6.09693C0 3.23775 2.44429 0.919922 5.30347 0.919922H64.601C67.887 0.919922 71.0162 2.32511 73.1994 4.78109L94.3108 28.5306H0V6.09693Z",
		fill: "currentColor"
	})
});
export default SvgCardIllustration;
